<template>
    <div class="media-gallery-selector">
        <div v-if="value" class="selected-image tw-mb-2" @click="onShowGallery">
            <img :src="value">
        </div>
        <div class="image-buttons">
            <div class="ws-button small" @click="onShowGallery">Select New Image</div>
            <div v-if="value" class="ws-button small ws-button-negative" @click="onClear">Clear Image</div>
        </div>
        <modal v-if="showGallery" @close="showGallery = false" :width="750">
            <h3>Media Gallery</h3>
            <div class="modal-tabs" >
                <div class="modal-tab-header" :active="activeTab === 'upload'" @click="activateTab('upload')"><h5 class="tw-mb-0">Upload Image</h5></div>
                <div class="modal-tab-header" :active="activeTab === 'gallery'" @click="activateTab('gallery')"><h5 class="tw-mb-0">Media Gallery</h5></div>
            </div>
            <div class="large-form">
                <div class="modal-tab-content" :active="activeTab === 'upload'">
                    <div class="form-line">
                        <div class="form-field form-field-image-upload" id="form-field-image">
                            <label for="form-input-image">Upload Image</label>
                            <input id="form-input-image" accept="image/*" type="file" @change="onFileSelected">
                            <div class="field-note">Click above to upload a new image to your Media Gallery.</div>

                        </div>
                    </div>
                </div>
                <div class="modal-tab-content" :active="activeTab === 'gallery'">
                    <div class="form-line">
                        <div class="form-field form-field-image-gallery" id="form-field-image-gallery">
                            <div v-if="images.length" class="gallery-wrapper">
                                <div v-for="image in images" 
                                    :key="image" 
                                    @click="selectedImage = image" 
                                    class="tw-h-28 tw-w-28 tw-cursor-pointer"
                                    :class="{ 'selected': image === selectedImage }"
                                >
                                    <img :src="image" alt="" class="tw-h-full">
                                    <div class="delete-image" @click="deleteMedia(image)"></div>
                                </div>
                            </div>
                            <div v-else>
                                <p>No images in Media Gallery yet</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-actions">
                <div type="button" class="ws-button ws-button-secondary" @click="showGallery = false">Cancel</div>
                <div type="submit" class="ws-button ws-button-main" v-if="activeTab === 'upload'" 
                        @click.prevent="onUpload" 
                        :class="{ 'disabled': !uploadFile }">
                            Upload
                </div>
                <div type="submit" class="ws-button ws-button-main" v-if="activeTab === 'gallery'" 
                        @click="onSelect" 
                        :class="{ 'disabled': !images.length }">
                            Select
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { api } from "@/utils/client";
import Modal from "@/components/modals/Modal";

export default {
    name: 'MediaGallerySelector',
    components: {Modal},
    props: {
        value: {
            type: String,
        },
    },
    data() {
        return {
            showGallery: false,
            uploadFile: undefined,
            images: [],
            activeTab: 'upload',
            selectedImage: null
        }
    },
    methods: {
        async onShowGallery() {
            this.showGallery = true;
            const {data} = await api.get(`teams/${this.$store.state.teamId}/media`);
            this.images = data;
        },
        async deleteMedia(imageUrl) {
            let imageName = imageUrl.substring(imageUrl.lastIndexOf('/')+1);
            const {data} = await api.delete(`teams/${this.$store.state.teamId}/media/${imageName}`);
            this.images = data;
        },
        onFileSelected(ev) {
            this.uploadFile = ev.target.files[0]
        },
        onSelect() {
            this.$emit('input', this.selectedImage);
            this.showGallery = false;
        },
        onClear() {
            this.$emit('input', '');
        },
        async onUpload() {
            const formData = new FormData();
            formData.append('image', this.uploadFile);
            const headers = {'Content-Type': 'multipart/form-data'};
            const {data} = await api.post(`teams/${this.$store.state.teamId}/media`, formData, {headers});
            this.selectedImage = data;
            this.onSelect();
        },
        activateTab(tab) {
            this.activeTab = tab;
        },
    },

}
</script>
